





















































































































































































































































































































































































//@ts-nocheck
import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

//@ts-ignore
import usuarios from "@/mixins/axios/user";
@Component({
  components: {
    HelloWorld,
  },
   mixins: [usuarios],
 data() {
    return {
        render_menu:true,
        shc_tema:false,
        temas:[
            {key:'Verde',text:'Tema Verde'},
            {key:'Azul',text:'Tema Azul'},
            {key:'Rojo',text:'Tema Rojo'},
             {key:'Naranja',text:'Tema Naranja'}
        ]
    }},
  methods:{
      collapse(){
          $('body').toggleClass('collapsed-sidebar');
          $('.btncol').toggleClass('hide_b');
      },
      setRole(type){
          this.render_menu=false;
this.$store.state.user.usuario.role=type;
this.$store.commit('SETUSER',this.$store.state.user);
this.render_menu=true;
console.log(type)
      },
      show_l(index,type){
          this.render_menu=false;
          console.log(index)
          if(type=='admin'){
              this.$store.state.menus.admin[index].active=!this.$store.state.menus.admin[index].active;
          }else{
              console.log(this.$store.state.menus.municipios[index])
                this.$store.state.menus.municipios[index].active=!this.$store.state.menus.municipios[index].active;
          }
this.$store.commit('SETUSER',this.$store.state.user);
this.render_menu=true;
      },
      ToggleTemaC(){
this.shc_tema=!this.shc_tema;
console.log(this.shc_tema);
      },
     async setTema(key){
          this.$root.$emit("loading", true);
          let dat={tema:key };
let data = await this.EDITAR_USERTEMA(dat).then((response) => {
        if (response != null) {
          //this.plantas = response;
          console.log('holsss');
          console.log(response);
          this.$root.$emit(
            "success",
            "Tema modificado correctamentea"
          );
          this.$store.state.user.usuario.idtema=key;
            this.$store.commit('SETUSER',this.$store.state.user);
        } else {
          this.$root.$emit(
            "alerta_show",
            "Ocurrio un error al intentar seleccionar nuevo tema, refresque la pagina"
          );
        }
        this.$root.$emit("loading", false);
        //loading.close();
      });
      },
      tema_sel(){
if(this.$store.state.user.usuario.idtema==null){
return this.$store.state.user.municipio.idtema;
}
return this.$store.state.user.usuario.idtema;
      },
        activechild(index){
            //alert('sss')
            console.log(index)
        this.$store.state.menus.municipios[index].active=!this.$store.state.menus.municipios[index].active;
        console.log(this.$store.state.menus.municipios[index])
        },
        activechild2(index,index2){
            // alert('sss2')
            console.log(index)
        this.$store.state.menus.municipios[index].childs[index2].active=!this.$store.state.menus.municipios[index].childs[index2].active;
        console.log(this.$store.state.menus.municipios[index].childs[index2])
        }
  }
})
export default class Home extends Vue {}
